import { motion } from "framer-motion";
import { ShieldCheck, FileCheck, BadgeCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuote } from "@/context/QuoteContext";
import { WARRANTIES } from "@/data/site";

const ICONS = [ShieldCheck, FileCheck, BadgeCheck];

export const Warranties = () => {
  const { openQuote } = useQuote();

  return (
    <section id="warranties" data-testid="warranties-section" className="relative py-16 sm:py-20 lg:py-28 bg-slate-950 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_1px_1px,white_1px,transparent_0)] [background-size:32px_32px]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-red-600">Warranties That Set Us Apart</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white">
            Protection the Competition <span className="text-red-600">Can't Match</span>
          </h2>
          <p className="mt-4 text-lg text-slate-300 leading-relaxed">
            A great roof is only as good as the promise behind it. We back every project with layered coverage ,
            so your investment stays protected for decades.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {WARRANTIES.map((w, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`warranty-card-${i}`}
                className="rounded-2xl bg-white/5 border border-white/10 p-7 backdrop-blur-sm hover:bg-white/[0.08] hover:border-red-600/40 transition-all duration-300"
              >
                <div className="grid place-items-center h-12 w-12 rounded-xl bg-red-700 text-white mb-5">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display font-bold text-xl text-white">{w.title}</h3>
                <p className="mt-3 text-slate-300 leading-relaxed">{w.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 rounded-2xl bg-gradient-to-r from-red-700 to-red-800 p-7 lg:p-9">
          <div>
            <h3 className="font-display font-extrabold text-2xl text-white">Want it all in writing? Get a free, no-obligation quote.</h3>
            <p className="text-red-50 mt-1">See exactly what's covered and why we're the safest choice in California.</p>
          </div>
          <Button
            data-testid="warranties-quote-btn"
            onClick={() => openQuote()}
            size="lg"
            className="shrink-0 bg-white text-red-800 hover:bg-slate-900 hover:text-white font-bold rounded-full h-14 px-8 hover:scale-105 transition-transform"
          >
            Get My Free Quote <ArrowRight className="ml-1 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};
